import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import {
  getAllGroupMembers,
  queryGroups,
} from "../../../services/poweruserServices";
import { useAppContext } from "../../../contexts/AppContext";

const SelectGroupUser = ({ handleViewClick }) => {
  const { currentUser } = useAppContext();
  const enrollSelectBox = useRef(null);
  const [defaultListGroupOptions, setDefaultListGroupOptions] = useState([]);
  const [isListBoxLoading, setIsListBoxLoading] = useState(false);
  const [selectBoxValuesGroup, setSelectBoxValuesGroup] = useState();
  const [defaultListOptions, setDefaultListOptions] = useState([]);
  const [selectBoxValues, setSelectBoxValues] = useState([]);
  const [groupUsers, setGroupUsers] = useState([]);

  useEffect(() => {
    getPowerUserGroups();
  }, []);

  const getPowerUserGroups = async () => {
    setIsListBoxLoading(true);
    let userGroups = await queryGroups(currentUser.user_id);

    var result = userGroups.map((item) => {
      return { value: item.id, label: item.name, type: "group" };
    });

    setDefaultListGroupOptions(result);
    setIsListBoxLoading(false);

    if (result.length > 0) {
      const firstGroup = result[0];
      setSelectBoxValuesGroup(firstGroup);
      await handleSelectChangeGroup(firstGroup);
    }

    return result;
  };

  const handleSelectChangeGroup = async (selectedOptions) => {
    setIsListBoxLoading(true);
    setSelectBoxValuesGroup(selectedOptions);
    let groupId = selectedOptions?.value?.toString();
    let groupUsers = await getAllGroupMembers(groupId);

    let listGroupUsers = groupUsers.map((item) => {
      return {
        value: item.id,
        label: item.username+" ( "+item.firstname+" "+item.lastname+" )",
        type: "user",
        email: item.email,
        firstname: item.firstname,
        lastname: item.lastname,
         username:item.username
      };
    });

    setGroupUsers(listGroupUsers);
    setDefaultListOptions(listGroupUsers);
    setIsListBoxLoading(false);
    return listGroupUsers;
  };


const filterOptions = (candidate, input) => {
  const search = input.toLowerCase();

  return (
    candidate.data.label.toLowerCase().includes(search) ||
    candidate.data.email.toLowerCase().includes(search) ||
    candidate.data.value.toString().toLowerCase().includes(search) ||
    candidate.data.firstname.toLowerCase().includes(search) ||
      candidate.data.lastname.toLowerCase().includes(search) ||

      (candidate.data.firstname + ' ' + candidate.data.lastname)
          .toLowerCase()
          .includes(search)
  );
};

  return (
    <div className="select_group_users_container">
      <div className="select_group_and_user_filter">
        <div className="select_group">
          <div>Select Group</div>
          <Select
            ref={enrollSelectBox}
            options={defaultListGroupOptions}
            onChange={(e) => handleSelectChangeGroup(e)}
            isLoading={isListBoxLoading}
            filterOption={filterOptions}
            value={selectBoxValuesGroup}
          />
        </div>
        <div className="select_users">
          <div>Select User</div>
          <Select
            ref={enrollSelectBox}
            value={selectBoxValues}
            options={defaultListOptions}
            onChange={setSelectBoxValues}
            isLoading={isListBoxLoading}
            filterOption={filterOptions}
          />
        </div>
      </div>
      <div className="view_button">
        <div style={{ width: "100px" }}>
          <button
            className={
              selectBoxValues?.length === 0 ? "button-disabled" : "button"
            }
            onClick={() => handleViewClick(selectBoxValues)}
            disabled={selectBoxValues?.length === 0}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            <span style={{ marginLeft: "4px" }}>View</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectGroupUser;
